export const config = {
  title: 'LWS Liburd Remodeling',
  meta: {
    description:
      'LWS Liburd Remodeling offers expert interior remodeling and custom carpentry services in Tamarac, FL. Transform your home with our personalized solutions.',
    keywords: [
      'Home Remodeling Tamarac FL',
      'Custom Carpentry',
      'Kitchen Renovation',
      'Bathroom Remodeling',
      'LWS Liburd Remodeling',
    ],
    author: 'LWS Liburd Remodeling',
    canonicalUrl: 'https://www.lwsinteriorremodelling.com/',
  },
  sections: {
    header: {
      businessName: 'LWS Liburd Remodeling',
    },
    sectionB: {
      heroTitle: 'LWS Liburd Remodeling',
      heroSubtitle: 'Transforming Homes with Precision and Style in Tamarac, FL',
      learnAboutText: 'Discover Our Services',
      phoneNumber: '9544870320',
      phoneLabel: '(954) 487-0320',
      heroBackgroundImage:
        'https://lirp.cdn-website.com/b4468daa/dms3rep/multi/opt/99218a98fe53d9703c4db909941da706-1061w.jpg',
      cardData: [
        {
          title: 'Custom Carpentry',
          description:
            'We craft personalized woodwork solutions tailored to your home’s unique style.',
        },
        {
          title: 'Expert Remodeling',
          description:
            'Our team delivers high-quality kitchen and bathroom renovations with attention to detail.',
        },
        {
          title: 'Reliable Service',
          description:
            'With over 30 years of experience, we ensure dependable and timely project completion.',
        },
      ],
      description:
        'At LWS Liburd Remodeling, we specialize in transforming living spaces through expert remodeling and custom carpentry services. Serving Tamarac, FL, we are committed to enhancing your home’s functionality and aesthetic appeal.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our range of remodeling and carpentry services designed to elevate your home.',
      cards: [
        {
          title: 'Bathroom Renovation',
          description:
            'Transform your bathroom into a relaxing and stylish space.',
          imageSrc: 'https://lirp.cdn-website.com/b4468daa/dms3rep/multi/opt/b1b0bfef282eeed506b9d706891fb087-1920w.jpg',
          imageAlt: 'Bathroom Renovation',
        },
        {
          title: 'Kitchen Remodeling',
          description:
            'Upgrade your kitchen with modern designs and functional layouts.',
          imageSrc: 'https://lirp.cdn-website.com/b4468daa/dms3rep/multi/opt/1ad6eadf659c40a55151aeee805f90f2-1920w.jpg',
          imageAlt: 'Kitchen Remodeling',
        },
        {
          title: 'Custom Carpentry',
          description:
            'From built-ins to trim work, we provide bespoke carpentry solutions.',
          imageSrc: 'https://lirp.cdn-website.com/b4468daa/dms3rep/multi/opt/0d490e9b71e39cf990ddbb029f6a2cc2-1920w.jpg',
          imageAlt: 'Custom Carpentry',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Interior & Exterior Finishes',
        'Painting',
        'Patios',
        'Hardwood Flooring',
        'Tiling',
        'Stair Installations',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://lirp.cdn-website.com/b4468daa/dms3rep/multi/opt/36809a7e436fa427a2960353e1471dee-1920w.png',
        alt: 'LWS Liburd Remodeling Team',
      },
      aboutText: [
        'LWS Liburd Remodeling is a family-owned business with over 30 years of experience in home remodeling and custom carpentry.',
        'Our mission is to provide high-quality, personalized remodeling solutions that enhance the functionality and beauty of your home. We pride ourselves on our craftsmanship, attention to detail, and exceptional customer service.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'LWS Liburd Remodeling Logo',
      businessName: 'LWS Liburd Remodeling',
      contact: {
        phone: '9544870320',
        phoneLabel: '(954) 487-0320',
        email: 'liburdwoodworkshop4@hotmail.com',
        website: 'https://www.lwsinteriorremodelling.com/',
        address: '7215 NW 76th Pl, Tamarac, FL 33321, US',
      },
      socialMedia: {
        facebook: null,
        twitter: null,
        instagram: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '7215 NW 76th Pl, Tamarac, FL 33321, US',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3589.123456789012!2d-80.1234567!3d26.1234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9abcdef123456%3A0xabcdef1234567890!2s7215%20NW%2076th%20Pl%2C%20Tamarac%2C%20FL%2033321%2C%20USA!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus',
    },
  },
};

export default config;
